import { render, staticRenderFns } from "./user-landing-view.vue?vue&type=template&id=d22a5cfa&"
import script from "./user-landing-view.vue?vue&type=script&lang=js&"
export * from "./user-landing-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports